if(!customElements.get('product-info')){
    class ProductInfo extends HTMLElement {
        constructor(){
            super();

            this.sectionProduct = this.closest('.product, .variant-popup');
            this.productMedia = this.sectionProduct?.querySelector('product-media');
            this.sectionId = this.dataset.sectionId;
        
            this.cartDrawer = document.querySelector('cart-drawer');
            this.addedToCartPopup = document.querySelector('added-to-cart-popup');
            this.initializeProductForm();

            // load media for selected variant
            const selectedVariantJsonData = JSON.parse(this.sectionProduct.querySelector('#json-selected-variant').textContent);
            const mediaId = selectedVariantJsonData?.featured_media?.id;
            this.updateMedia(mediaId);
            this.productMedia?.classList.remove('opacity-0');
        }

        onVariantChangeUnsubscriber = undefined;
        abortController = undefined;
        connectedCallback(){
            this.whatsappListenerController?.abort();
            this.whatsappListenerController = new AbortController();
            ['input', 'change', 'click', 'keydown'].forEach(type => {
                this.addEventListener(type, () => this.updateWhatsappQuantity(), {
                    signal: this.whatsappListenerController.signal
                });
            });
            this.updateWhatsappQuantity();
            this.onVariantChangeUnsubscriber = PubSub.subscribe(
                PubSub.events.optionValueSelectionChange, this.handleOptionValueChange.bind(this)
            );
        }

        disconnectedCallback() {
            this.whatsappListenerController?.abort();
            if (this.onVariantChangeUnsubscriber && typeof this.onVariantChangeUnsubscriber === 'function') {
                this.onVariantChangeUnsubscriber();
            }
        }

        updateWhatsappQuantity(){
            const link = this.querySelector('[data-whatsapp-order]');
            if(!link) return;
            const input = this.querySelector('input[name="quantity"]');
            const quantity = Math.max(1, parseInt(input?.value, 10) || 1);
            const url = new URL(link.href);
            const message = url.searchParams.get('text');
            if(!message) return;
            url.searchParams.set('text', message.replace(/^Cantidad:.*$/m, `Cantidad: ${quantity}`));
            link.href = url.toString();
        }

        initializeProductForm(){
            // add to cart
            this.form = this.querySelector(`#product-form-${this.sectionId}`);
            this.buttonSubmit = this.querySelector('[type="submit"]');

            if(!this.form) return;
            if(!this.buttonSubmit) return;

            this.buttonSubmit.classList.remove("pointer-events-none");
            this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        }

        onSubmitHandler(e){
            e.preventDefault();
            if(this.buttonSubmit.getAttribute('disabled') === 'disabled') return;

            // handle error message
            this.handleErrorMessage();

            this.buttonSubmit.setAttribute('disabled', "disabled");
            this.buttonSubmit.classList.remove('disabled');
            this.buttonSubmit.classList.add('loading');

            const formData = new FormData(this.form);

            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];
            config.body = formData;

            fetch(`${routes.cart_add_url}`, config)
            .then(res => res.json())
            .then(res => {
                if(res.status) {
                    if(res.status === 422){ // quantity exceed available quantity
                        const message = res.message;

                        // extract available quantity from message, the message contains number.
                        const availableNumbers = message.match(/\d+/g)?.map(Number) || [];
                        const availableQuantity = availableNumbers.length > 0 ? availableNumbers[0] : 1;
                        PubSub.publish(PubSub.events.exceedAvailableQuantity, {
                            productVariantId: formData.get('id'),
                            availableQuantity: availableQuantity
                        });

                        this.updateCartSize();
                    }

                    PubSub.publish(PubSub.events.cartError, {
                        source: 'product-form',
                        productVariantId: formData.get('id'),
                        errors: res.errors || res.description,
                        message: res.message
                    });

                    this.handleErrorMessage(res.description);

                    const recipientCheckbox = this.querySelector(`#checkbox-recipient-${this.sectionId}`);
                    const isRecipientFormError = recipientCheckbox?.checked && typeof res.errors === 'object' && res.errors !== null;

                    if(!isRecipientFormError){
                        // sold out
                        this.buttonSubmit.querySelector('.button-cart__text').innerHTML = window.cart.sold_out;
                        this.buttonSubmit.classList.remove('loading');
                        this.buttonSubmit.classList.add('disabled');
                        this.buttonSubmit.setAttribute('disabled', 'disabled');

                        const soldoutBadge = document.createElement('span');
                        soldoutBadge.innerHTML = window.cart.badge.sold_out;
                        soldoutBadge.classList.add('badge');
                        soldoutBadge.classList.add('badge--sold-out');
                        soldoutBadge.classList.add('my-3');
                        this.querySelector(".price").append(soldoutBadge);
                        this.querySelector('.price').classList.add('price--sold-out');
                        this.querySelector('.price').classList.remove('price--on-sale');
                        this.querySelector('.price').classList.remove('price--no-compare');
                        this.querySelector('.price').classList.remove('volumn-pricing--sale-badge');
                    }

                    this.error = true;
                    return;
                }
                
                if(!this.cartDrawer){ // if cart drawer is disabled
                    window.location = window.routes.cart_url;
                    return;
                }else{
                    PubSub.publish(PubSub.events.cartUpdate, {
                        source: 'cart-reload'
                    });
                }
                
                this.error = false;

                if(this.addedToCartPopup){
                    this.addedToCartPopup.renderContent(res);
                }else{ // if added to cart popup is disabled
                    this.updateCartSize();
                }

                PubSub.publish(PubSub.events.onSubmitProductForm, {});
            }).catch(e => {
                console.error(e);
            }).finally(() => {
                if(!this.buttonSubmit.classList.contains('disabled')){
                    this.buttonSubmit.removeAttribute('disabled');
                }
              
                this.buttonSubmit.classList.remove('loading');
            });
        }

        handleErrorMessage(message = ""){
            const errorWrapper = this.querySelector("product-form .error");
            if(!errorWrapper) return;

            if(typeof message === 'string' && message.trim() !== ''){
                errorWrapper.querySelector('small').innerText = `${message}`;
            }
        }

        handleOptionValueChange({ data: { event, target, selectedOptionValues, source }}){
            if (!this.contains(event.target)) return;

            const productUrl = target.dataset.productUrl || this.pendingRequestUrl;
            const productId = target.dataset.optionValueId;
            this.pendingRequestUrl = productUrl;
            const updateURL = source === 'main-product';

            this.renderProductInfo({
                requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues),
                targetId: productId,
                callback: this.updateProductInfo(productUrl, updateURL)
            });
        }

        updateProductInfo(productUrl, updateUrl = false){
            return (html) => {
                const selectedVariantJsonData = JSON.parse(html.querySelector('#json-selected-variant').textContent);
                const mediaId = selectedVariantJsonData?.featured_media?.id;
                const variantId = selectedVariantJsonData.id;

                this.updateProductForm(html);
                this.updateMedia(mediaId);
                this.updatePrice(html);
                this.updatePickupAvailability(html);
                this.updateSKU(html);
                this.updateVariantSelector(html);
                this.updateInventory(html);
                this.updateComparePriceCheckbox(html);
                this.updateQuantitySelector(html);
                this.updateWhatsappQuantity();

                if(updateUrl) this.updateURL(productUrl, variantId);
            }
        }

        buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false){
            const params = [];

            !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

            if(optionValues.length) {
                params.push(`option_values=${optionValues.join(',')}`);
            }

            return `${url}?${params.join('&')}`;
        }

        renderProductInfo({requestUrl, targetId, callback}){
            this.abortController?.abort();
            this.abortController = new AbortController();

            fetch(requestUrl, { signal: this.abortController.signal })
            .then((res) => res.text())
            .then((resText) => {
                this.pendingRequestUrl = null;
                const html = new DOMParser().parseFromString(resText, 'text/html');
                callback(html);
            })
            .catch((error) => {
                if(error.name === 'AbortError') {
                    console.log('Fetch aborted by user');
                }else{
                    console.error(error);
                }
            });
        }

        updateMedia(mediaId){
            if(!this.productMedia) return;
            if(!mediaId) return;

            this.productMedia.querySelectorAll('product-media-slide').forEach(item => {
                const currentMediaId = item.dataset.mediaId;

                if(`${mediaId}` === `${currentMediaId}`){
                    const index = item.dataset.index;
                    if(index) this.productMedia.updateSlideByIndex(parseInt(index));
                }
            });
        }

        updateQuantitySelector(html){
            const newQuantitySelectorHTML = html.querySelector('.quantity-selector');
            const oldQuantitySelector = this.querySelector('.quantity-selector');

            if(newQuantitySelectorHTML && oldQuantitySelector && oldQuantitySelector.parentNode){
                oldQuantitySelector.parentNode.replaceChild(newQuantitySelectorHTML.cloneNode(true), oldQuantitySelector);
                return;
            }

            if(oldQuantitySelector) oldQuantitySelector.setAttribute('aria-hidden', 'true');
        }

        updatePrice(html){
            const newPriceHTML = html.querySelector('.price');
            const oldPrice = this.querySelector(".price");
            
            if(newPriceHTML && oldPrice && oldPrice.parentNode){
                oldPrice.parentNode.replaceChild(newPriceHTML.cloneNode(true), oldPrice);
            }
        }

        updateSKU(html){
            const newSkuHTML = html.querySelector('.sku');
            const oldSku = this.querySelector(".sku");

            if(newSkuHTML && oldSku && oldSku.parentNode){
                oldSku.parentNode.replaceChild(newSkuHTML.cloneNode(true), oldSku);
                return;
            }

            if(oldSku) oldSku.setAttribute('aria-hidden', 'true');
        }

        updatePickupAvailability(html){
            const newPickupAvailabilityHTML = html.querySelector('pickup-availability');
            const oldPickupAvailability = this.querySelector('pickup-availability');

            if(!oldPickupAvailability) return;

            if(newPickupAvailabilityHTML){
                const newVariantId = newPickupAvailabilityHTML.dataset.variantId;
                if(oldPickupAvailability.dataset.variantId !== newVariantId){
                    oldPickupAvailability.dataset.variantId = newVariantId;
                }
            } else {
                oldPickupAvailability.setAttribute('aria-hidden', 'true');
            }
        }

        updateInventory(html){
            const newInventoryHTML = html.querySelector(".inventory");
            const oldInventory = this.querySelector(".inventory");

            if(newInventoryHTML && oldInventory && oldInventory.parentNode){
                oldInventory.parentNode.replaceChild(newInventoryHTML.cloneNode(true), oldInventory);
            }
        }

        updateComparePriceCheckbox(html){
            const newComparePriceCheckboxHTML = html.querySelector('.compare-product-checkbox');
            const oldComparePriceCheckbox = this.querySelector('.compare-product-checkbox');
            
            if(newComparePriceCheckboxHTML && oldComparePriceCheckbox && oldComparePriceCheckbox.parentNode){
                oldComparePriceCheckbox.parentNode.replaceChild(newComparePriceCheckboxHTML.cloneNode(true), oldComparePriceCheckbox);
                return;
            }
        }

        updateVariantSelector(html){
            const newVariantSelectorHTML = html.querySelector('.variant-selector');
            const oldVariantSelector = this.querySelector('.variant-selector');

            if(newVariantSelectorHTML && oldVariantSelector && oldVariantSelector.parentNode){
                oldVariantSelector.parentNode.replaceChild(newVariantSelectorHTML.cloneNode(true), oldVariantSelector);

                const insertedSelector = this.querySelector('variant-selector');
                if(insertedSelector && typeof insertedSelector.initialize === 'function'){
                    insertedSelector.initialize();
                }
                return;
            }

            if(oldVariantSelector) oldVariantSelector.setAttribute('aria-hidden', 'true');
        }

        updateProductForm(html) {
            const newProductFormHTML = html.querySelector('.product-form');
            const oldProductForm = this.querySelector('.product-form');

            if(newProductFormHTML && oldProductForm && oldProductForm.parentNode){
                if(newProductFormHTML.querySelector('[type="submit"]')){
                    newProductFormHTML.querySelector('[type="submit"]').classList.remove('pointer-events-none');
                }
                oldProductForm.parentNode.replaceChild(newProductFormHTML.cloneNode(true), oldProductForm);

                this.initializeProductForm();
            }
        }

        updateURL(productUrl, variantId){
            window.history.replaceState({ }, '', `${productUrl}?variant=${variantId}`);
        }

        updateCartSize(){
            const cartIconURL = `/?section_id=header-cart-icon`;
            fetch(cartIconURL)
            .then(res => {
                if (!res.ok) {
                    var error = new Error(res.status);
                    throw error;
                }
                return res.text();
            }).then(text => {
                const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-header-cart-icon').innerHTML;

                const header = document.querySelector('custom-header');
                const cartSizeIcons = header?.querySelectorAll('.cart-item-size');
                if(cartSizeIcons.length > 0){
                    cartSizeIcons.forEach(item => {
                        item.innerText = resultsMarkup.trim();
                        item.setAttribute('aria-hidden', 'false');
                    });
                }
            }).catch(e => {
                console.error(e);
            });
        }
    }

    customElements.define('product-info', ProductInfo);
}
